var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgT7 = function SvgT7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.36 0a.838.838 0 0 1 .675.402l1.899 3.61a.796.796 0 0 1-.082.781l-.033.048-6.61 7.002a.339.339 0 0 1-.29.157.343.343 0 0 1-.288-.162L.134 4.726a.797.797 0 0 1-.058-.78l1.9-3.542c.145-.238.4-.39.68-.404h8.705-.001ZM5.333 4.722a.502.502 0 0 0-.848.284.493.493 0 0 0 .083.348l.058.07 2.12 2.103a.5.5 0 0 0 .312.143h.086l.084-.014a.499.499 0 0 0 .157-.07l.07-.058 2.12-2.106a.494.494 0 0 0-.286-.84.503.503 0 0 0-.351.082l-.07.057L7.1 6.475 5.332 4.721v.001Z",
    fill: "#fff"
  })));
};

export default SvgT7;